import Marquee from "react-fast-marquee";
import { Star, Quotes, GoogleLogo } from "@phosphor-icons/react";
import { TESTIMONIALS, GOOGLE_REVIEW } from "../data";

const ReviewCard = ({ t }) => (
  <figure
    data-testid={`testimonial-${t.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    className="w-[320px] sm:w-[360px] shrink-0 mx-3 bg-white border-2 border-ink p-6 flex flex-col h-[280px]"
  >
    <div className="flex items-center justify-between">
      <Quotes weight="fill" size={28} className="text-sun" />
      <div className="flex gap-0.5">
        {Array.from({ length: t.rating }).map((_, k) => (
          <Star key={k} weight="fill" size={15} className="text-brandred" />
        ))}
      </div>
    </div>
    <blockquote className="mt-4 text-ink/80 text-sm leading-relaxed flex-1 overflow-hidden">
      <span className="line-clamp-5">"{t.quote}"</span>
    </blockquote>
    <figcaption className="mt-4 pt-4 border-t border-ink/10 flex items-center justify-between">
      <div>
        <p className="font-display font-bold text-ink leading-tight">{t.name}</p>
        <p className="text-xs text-ink/50 uppercase tracking-wider">{t.role}</p>
      </div>
      <GoogleLogo weight="bold" size={20} className="text-ink/40 shrink-0" />
    </figcaption>
  </figure>
);

export const Testimonials = () => {
  const half = Math.ceil(TESTIMONIALS.length / 2);
  const rowA = TESTIMONIALS.slice(0, half);
  const rowB = TESTIMONIALS.slice(half);

  return (
    <section id="reviews" data-testid="reviews-section" className="py-20 sm:py-28 bg-paper grain relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <div className="mb-12 max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-brandred mb-3">Highly recommended by the community</p>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] text-ink">
            The best-rated ride in <span className="text-brandblue">Windsor.</span>
          </h2>
          <div className="mt-5 inline-flex items-center gap-3 bg-ink text-white px-4 py-2.5" data-testid="reviews-rating">
            <GoogleLogo weight="bold" size={20} className="text-sun" />
            <div className="flex gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => (<Star key={i} weight="fill" size={16} className="text-sun" />))}
            </div>
            <span className="font-display font-bold">5.0</span>
            <span className="text-white/60 text-sm">· Real reviews from Google</span>
          </div>
          <div className="mt-5">
            <a
              data-testid="leave-review-btn"
              href={GOOGLE_REVIEW}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-sun text-ink font-bold px-6 py-3 border-2 border-ink shadow-hard-sm hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-all duration-150"
            >
              <Star weight="fill" size={18} /> Leave us a review on Google
            </a>
          </div>
        </div>
      </div>

      {/* Row 1 — scrolls left */}
      <Marquee speed={38} pauseOnHover gradient={false} className="py-2">
        {rowA.map((t) => (<ReviewCard key={t.name} t={t} />))}
      </Marquee>
      {/* Row 2 — scrolls right */}
      <Marquee speed={38} direction="right" pauseOnHover gradient={false} className="py-2 mt-3">
        {rowB.map((t) => (<ReviewCard key={t.name} t={t} />))}
      </Marquee>

      <p className="text-center text-xs text-ink/40 mt-8">Hover to pause · swipe to explore more 5-star reviews</p>
    </section>
  );
};
